import React, { useRef, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import Drawer from "../../common/Drawer";
import { Heading } from "../../../styles/component/style";
import CustomTable from "../../common/CustomTable/CustomTable";
import CaseService from "../../../services/CaseService";
import moment from "moment";
import queryString from "query-string";
import { getErrorMessage, parseTimeStamp } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { makeStyles, Tooltip } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DrawerRecording from "../../internal/ViewRecordings/index";
import DocViewers from "./DocViewer";
import ViewKeywords from "./ViewExtract";
import AudioRecordings from "../MeetingAudioDetails/index";

const docTypes = [
  { ownerType: "claimant", title: "Claimant Documents" },
  { ownerType: "respondent", title: "Respondent Documents" },
  { ownerType: "common", title: "Neutral's Documents" },
];

async function getCaseDocument(id, query) {
  try {
    const response = await CaseService.getcaseDocuments(id, query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const Index = ({ state, setState, id, type, claimantId, respondentId }) => {
  return (
    <Drawer state={state} setState={setState} label="Drawer">
      <Table {...{ setState, id, type, claimantId, respondentId }} />
    </Drawer>
  );
};

export default Index;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f9f9f9",
    border: "solid 0.5px #e1e3ee",
    boxShadow: "none",
    margin: "16px 0px 0px !important",
    "& .MuiAccordionSummary-content": {
      margin: "27px 0 27px 24px !important",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: 15,
      backgroundColor: "#fff",
    },
    "& .MuiSvgIcon-root": {
      fill: "#00838c",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Table = ({ setState, id, type, claimantId, respondentId }) => {
  const [urls, setUrls] = useState([]);
  const [trigger, setTrigger] = useState(false);

  const downloadFiles = async () => {
    try {
      const downloadPromises = urls.map(async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.download = url.substring(url.lastIndexOf("/") + 1);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      });
      await Promise.all(downloadPromises);
    } catch (error) {
      console.error("Error downloading files:", error);
    } finally {
      setTrigger(true);
      setUrls([]);
    }
  };

  return (
    <div>
      <Header>
        <Heading style={{ marginBottom: "unset", display: "flex" }}>
          Case Documents
          {urls.length ? (
            <Card>
              <div className="add_circle" onClick={downloadFiles}>
                <img
                  src={require("../../../assets/images/JustAct Icons Download-02.svg")}
                  alt="submit"
                />
              </div>
            </Card>
          ) : null}
        </Heading>
        <ImageWrapper>
          <img
            src={require("../../../assets/images/closeModal.svg")}
            onClick={() => {
              setState(false);
            }}
            alt="close"
          />
        </ImageWrapper>
      </Header>
      <AccordionContainer>
        {docTypes
          .filter((item) =>
            type === "negotiation" ? item.ownerType !== "mediator" : true
          )
          .map((item) => (
            <TableWithAccordion
              {...item}
              {...{
                id,
                claimantId,
                respondentId,
                setUrls,
                trigger,
                setTrigger,
              }}
            />
          ))}
        {type !== "negotiation" ? (
          <DrawerRecording
            title="View Recordings"
            {...{ id, setState, type }}
          />
        ) : (
          ""
        )}
        {type !== "negotiation" ? <AudioRecordings {...{ id, type }} /> : null}
      </AccordionContainer>
    </div>
  );
};

function TableWithAccordion({
  id,
  title,
  ownerType,
  setUrls,
  trigger,
  setTrigger,
}) {
  const classes = useStyles();
  const [result, setResult] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [docview, setDocView] = useState({ state: false });
  const [view, setView] = useState({ state: false });
  const MTRef = useRef();

  useEffect(() => {
    if (trigger) {
      if (MTRef.current) {
        MTRef.current.onQueryChange(MTRef?.current?.state?.query);
        setTrigger(false);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  // Document title

  const styleTitle = (uploadType) => {
    return uploadType === "Request for Arbitration" ? (
      <DocTitle style={{ color: "#0000FF" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Documents filed along with the Request for Arbitration" ? (
      <DocTitle style={{ color: "#FF1493" }}>{uploadType}</DocTitle>
    ) : uploadType === "Statement of Claim" ? (
      <DocTitle style={{ color: "#4B0082" }}>{uploadType}</DocTitle>
    ) : uploadType === "Documents filed along with the Statement of Claim" ? (
      <DocTitle style={{ color: "#8B008B" }}>{uploadType}</DocTitle>
    ) : uploadType === "Application (to be filed as per IIAC Regulations)" ? (
      <DocTitle style={{ color: "#006400" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Replies/ Counter Affidavits /Rejoinder Affidavits etc" ? (
      <DocTitle style={{ color: "#FFBF00" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Claimant Evidence Statement and any document filed along with it" ? (
      <DocTitle style={{ color: "#FF7F50" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Statement/Affidavit of Admission and Denial of Documents" ? (
      <DocTitle style={{ color: "#DE3163" }}>{uploadType}</DocTitle>
    ) : uploadType === "Response to the Request for Arbitration" ? (
      <DocTitle style={{ color: "#ff3c3c" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Documents filed along with the Response to the Request for Arbitration" ? (
      <DocTitle style={{ color: "#6495ED" }}>{uploadType}</DocTitle>
    ) : uploadType === "Statement of Defence /Counter Claim" ? (
      <p style={{ color: "#40E0D0" }}>{uploadType}</p>
    ) : uploadType ===
      "Documents filed along with the Defence /Counter Claim" ? (
      <DocTitle style={{ color: "#FF00FF" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Respondent Evidence Statement and any document filed along with it" ? (
      <DocTitle style={{ color: "#800080" }}>{uploadType}</DocTitle>
    ) : uploadType === "Any other document" ? (
      <DocTitle style={{ color: "#00838c" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "IIAC Case Portal to be capable to file all documents as are provided in A and B above" ? (
      <DocTitle style={{ color: "#0000FF" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Documents/order(s) passed by the Hon’ble Chairperson in the matters of appointment of the Arbitrators" ? (
      <DocTitle style={{ color: "#FF1493" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Documents/order(s) passed by the Hon’ble Chairperson in the matters relating to various applications may be filed as per the IIAC Regulations" ? (
      <DocTitle style={{ color: "#4B0082" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Documents/order(s) passed by the Arbitral Tribunal in the matters relating to various applications may be filed as per the IIAC Regulations" ? (
      <DocTitle style={{ color: "#8B008B" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Various order/procedural orders passed by the Arbitral Tribunal" ? (
      <DocTitle style={{ color: "#006400" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Various correspondences exchanged between IIAC/Parties/Tribunal" ? (
      <DocTitle style={{ color: "#d91b1b" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Various invoices/payment related document regarding – Filing Fee, Administration Fee, Arbitrators Fee, Misc. Administration Charges etc. as per the IIAC Regulations" ? (
      <DocTitle style={{ color: "#FF7F50" }}>{uploadType}</DocTitle>
    ) : uploadType ===
      "Upload Declaration of acceptance and Statement of Independence by the Arbitrator" ? (
      <DocTitle style={{ color: "#0000FF" }}>{uploadType}</DocTitle>
    ) : (
      <DocTitle>{uploadType}</DocTitle>
    );
  };

  const columns = [
    {
      field: "documentNo",
      title: "Doc ID",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          onClick={() => window.open(rowData.url?.url, rowData?.name)}
          style={{ width: 50 }}
        >
          {rowData.documentNo}
        </HyperLink>
      ),
    },
    {
      field: "url",
      title: "Document",
      sorting: false,
      render: (rowData) => (
        <Tooltip
          title={rowData?.url?.url?.split("?")[0].split("/").pop()}
          placement="top"
        >
          <HyperLink
            onClick={(event) => {
              event.preventDefault();
              setDocView({
                state: true,
                url: rowData?.url?.url,
                name: rowData?.name,
                title: rowData?.entity?.title,
              });
            }}
            style={{ width: 150 }}
          >
            {rowData?.name || "-"}
          </HyperLink>
        </Tooltip>
      ),
      headerStyle: {
        padding: `12px 16px`,
      },
      cellStyle: {
        padding: `12px 16px`,
      },
    },
    {
      field: "owner.name",
      title: "Submitted By",
      sorting: false,
      headerStyle: {
        padding: `12px 16px`,
      },
      cellStyle: {
        padding: `12px 16px`,
      },
    },
    {
      field: "date",
      title: "Date",
      sorting: false,
      render: (rowData) => (
        <StyledTitle>
          <div>
            {rowData.created_at &&
              moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}
          </div>
          <div>
            {rowData.created_at &&
              moment(parseTimeStamp(rowData.created_at)).format("hh:mm A")}
          </div>
        </StyledTitle>
      ),
      headerStyle: {
        maxWidth: 150,
        width: 150,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 150,
        width: 150,
        padding: `12px 16px`,
      },
    },
    {
      field: "type",
      title: "Document Type",
      sorting: false,
      render: (rowData) => (
        <StyledTitle
          style={{
            paddingLeft: "15px",
          }}
        >
          <Tooltip placement="top" title={rowData?.url?.uploadType}>
            {styleTitle(rowData?.url?.uploadType)}
          </Tooltip>
        </StyledTitle>
      ),
      headerStyle: {
        maxWidth: 150,
        width: 150,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 150,
        width: 150,
        padding: `12px 16px`,
      },
    },
    {
      field: "extract",
      title: "Extract",
      sorting: false,
      render: (rowData) =>
        rowData?.keywords ? (
          <HyperLink
            onClick={() =>
              setView({
                state: true,
                keywords: rowData?.keywords,
                documentSummary: rowData?.documentSummary,
              })
            }
          >
            {"View"}
          </HyperLink>
        ) : (
          <div style={{ paddingLeft: 12 }}>{"-"}</div>
        ),
      headerStyle: {
        padding: `12px 16px`,
      },
      cellStyle: {
        paddingLeft: 18,
      },
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let payload = {
        page: query.page + 1,
        perPage: 10,
      };
      if (ownerType) {
        if (ownerType === "claimant") {
          payload.claimantView = true;
        } else if (ownerType === "respondent") {
          payload.respondentView = true;
        } else {
          payload.commonView = true;
        }
      }
      const stringParams = `?${queryString.stringify(payload)}`;
      getCaseDocument(id, stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
            });
            setResult(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setResult({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <>
      <Accordion className={classes.root}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <AccordionHeading>
            {title} ({result?.total})
          </AccordionHeading>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer>
            <CustomTable
              selection
              onSelectionChange={(selected) =>
                setUrls(selected.map((item) => item?.url?.url))
              }
              pluralTitle="Documents"
              singularTitle=""
              {...{
                columns,
                data,
                MTRef,
              }}
              noToolbar
              pageSize={10}
              hidePagination={result.lastPage === 1}
              state={result}
            />
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <ViewKeywords {...{ view, setView }} />
      <DocViewers {...{ docview, setDocView }} />
    </>
  );
}

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 40px;
  margin-top: 15px;
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
`;
export const TableContainer = styled.div`
  /* margin: 30px 29px auto 38px; */
  width: 100%;
`;
export const AccordionHeading = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
`;

export const AccordionContainer = styled.div`
  padding: 0 20px;
`;

export const ImageWrapper = styled.div`
  cursor: pointer;
`;
export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledTitle = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  min-width: 100px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;
  margin: 0 auto;
  @media (min-width) {
    justify-content: space-between;
  }
`;

export const CheckedIconContainer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  width: 32px;
  display: flex;
  border-radius: 7px;
  align-items: center;
  justify-content: space-between;
  margin-left: 10px;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
      & .add_circle {
        cursor: not-allowed !important;
      }
    `}

  & .add_circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 23px;
    border-radius: 100%;
    cursor: pointer;
    background-color: rgba(0, 131, 140, 0.13);
  }
  & .add_icon {
    color: ${COLORS.BTN_GREEN};
    font-size: 18px;
  }
`;

const DocTitle = styled.div`
  width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
